import { useHistory } from 'react-router-dom';
import { DateTime } from 'luxon';

import {
  TeacherAssignmentTypeEnum,
  useCreateQuizMutation,
} from '@school_ify/schoolify-repository/src/teacher/types';

import { CreateEditQuizModel } from 'types/quiz';

import CreateQuizForm from '../shared/CreateQuizForm/CreateQuizForm';

import './CreateQuiz.scoped.scss';

const CreateQuiz: React.FC = () => {
  const history = useHistory();
  const [createQuizMutation] = useCreateQuizMutation();

  const onCreateQuiz = (model: CreateEditQuizModel) => {
    createQuizMutation({
      variables: {
        quiz: {
          attempts: model.attempts,
          pass_percentage: model.passPercentage,
          time_control: model.timeControl,
          assignment: {
            data: {
              description: model.description,
              title: model.title,
              teaching_structure_id: model.teaching_structure_id,
              type: TeacherAssignmentTypeEnum.QUIZ,
              duration: model.duration,
              due_at: DateTime.now().toISO(),
            },
          },
        },
      },
      onCompleted: fetchedData => {
        if (fetchedData?.insert_assignment_quiz_one?.assignment) {
          history.push(`/quiz/edit/${fetchedData?.insert_assignment_quiz_one?.assignment?.id}`);
        }
      },
    });
  };

  return (
    <div className="create-quiz-container">
      <div className="create-quiz-center">
        <div className="quiz-components-wrapper">
          <CreateQuizForm onSave={onCreateQuiz} />
        </div>
      </div>
    </div>
  );
};

export default CreateQuiz;
